import React from "react";
import { LimitedTag } from "./LimitedTag";
import InputControl from "./InputControl";
import {
  Box,
  Checkbox,
  Chip,
  InputAdornment,
  ListItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";

export const AutocompleteWithEndAdornmentChip = ({
  options,
  name,
  label,
  value,
  handleChangeFilter,
  placeholder = "",
  limitedTag = (value) => (
    <LimitedTag
      labelKey="label"
      value={value}
      autocompleteWidth={"200px"}
      labelWidth="10px"
    />
  ),
  helperText = null,
  ...rest
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <InputControl
      type="dropdown"
      name={name}
      label={label}
      multiple={true}
      options={options}
      value={value}
      disableCloseOnSelect
      disableClearable={true}
      onChange={(_, value) => handleChangeFilter({ name, value })}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      renderTags={(value) => limitedTag(value)}
      renderOption={(props, option, { selected }) => (
        <ListItem {...props} key={option.value} disableGutters disablePadding>
          <Checkbox
            style={{ marginRight: 8 }}
            checked={selected}
            size="small"
          />
          {option.label}
        </ListItem>
      )}
      renderInput={(params) => {
        const values = params.InputProps.startAdornment?.props?.value;
        const overflowCount = values?.length - 1;
        return (
          <TextField
            {...params}
            label={label}
            placeholder={isOpen ? placeholder : ""}
            sx={{
              height: "auto",
            }}
            InputProps={{
              ...params.InputProps,
              readOnly: !isOpen,
              startAdornment: isOpen ? null : params.InputProps.startAdornment,
              endAdornment: params.InputProps.endAdornment && (
                <InputAdornment position="end">
                  <Stack
                    flexDirection="row"
                    whiteSpace="nowrap"
                    flexWrap="nowrap"
                    gap="4px"
                  >
                    {!isOpen && overflowCount > 0 && (
                      <Tooltip
                        title={
                          <Box
                            component="div"
                            maxHeight="400px"
                            sx={{ overflowY: "auto" }}
                          >
                            {values.map((value) => (
                              <Box component="div" key={value.label}>
                                {value.label}
                              </Box>
                            ))}
                          </Box>
                        }
                        arrow
                        placement="bottom-start"
                        slotProps={{
                          arrow: {
                            color: "rgba(25, 32, 41, 1)",
                          },
                          tooltip: {
                            sx: {
                              background: "rgba(25, 32, 41, 1)",
                              ".MuiTooltip-arrow::before": {
                                backgroundColor: "rgba(25, 32, 41, 1)",
                              },
                            },
                          },
                        }}
                      >
                        <Chip
                          label={`+${overflowCount}`}
                          sx={{ borderRadius: "8px" }}
                        />
                      </Tooltip>
                    )}
                    {params.InputProps.endAdornment}
                  </Stack>
                </InputAdornment>
              ),
            }}
            error={Boolean(helperText)}
            helperText={helperText}
          />
        );
      }}
      {...rest}
    />
  );
};
